import JSONPointerError from "./JSONPointerError.mjs";
class JSONPointerEvaluateError extends JSONPointerError {}
export default JSONPointerEvaluateError;